import { lazy, Suspense } from "react";
import { Loader } from "../_components/Loader";
import AmendmentView from "../_components/Amendment/AmendmentView";
import Profile from "../_components/Profile";


const Login = lazy(() =>
  import("../_components/Auth/Login")
);

const Dashboard = lazy(() =>
  import("../_components/Dashboard/Dashboard")
);

const Quotation = lazy(() =>
  import("../_components/Quotation")
);

const AddQuotation = lazy(() =>
  import("../_components/Quotation/AddQuotation")
);

const Region = lazy(() =>
  import("../_components/Master/Division/RegionMaster")
);

const Branch = lazy(() =>
  import("../_components/Master/Division/BranchMaster")
);

const Application = lazy(() =>
  import("../_components/Master/Terms/Application")
);

const Dept = lazy(() =>
  import("../_components/Master/Division/DeptMaster")
);

const GST_Terms = lazy(() =>
  import("../_components/Master/Terms/GST_Terms")
);

const MasterFreightTerm = lazy(() =>
  import("../_components/Master/Terms/MasterFreightTerm")
);

const MasterPlant = lazy(() =>
  import("../_components/Master/Division/Plant")
);

const DeliveryTerms = lazy(() =>
  import("../_components/Master/Terms/DeliveryTerms")
);

const TransporterTerms = lazy(() =>
  import("../_components/Master/Terms/TransporterTerms")
);

const IndustryType = lazy(() =>
  import("../_components/Master/Terms/Industry")
);

const Flow = lazy(() =>
  import("../_components/Flow/Flow")
);
const FlowView = lazy(() =>
  import("../_components/Flow/ViewFlow")
);

const AddFlow = lazy(() =>
  import("../_components/Flow/AddFlow")
);

const MyWorkingReport = lazy(() =>
  import("../_components/Flow/MyWorkingReport")
);

const Disassembly = lazy(() =>
  import("../_components/Disassembly/index")
);

const Amendment = lazy(() =>
  import("../_components/Amendment/index")
);

const AddAmendment = lazy(() =>
  import("../_components/Amendment/AddAmendment")
);

const FOC = lazy(() =>
  import("../_components/FOC/index")
);

const AddFoc = lazy(() =>
  import("../_components/FOC/AddFoc")
);

const FocView = lazy(() =>
  import("../_components/FOC/FocView")
);

const Discount = lazy(() =>
  import("../_components/Master/Others/Discount")
);

const SubDept = lazy(() =>
  import("../_components/Master/Division/SubDepMaster")
);

const WarrantyType = lazy(() =>
  import("../_components/Master/Terms/WarrantyType")
);

const Currency = lazy(() =>
  import("../_components/Master/Others/Currency")
);

const PaymentTerms = lazy(() =>
  import("../_components/Master/Terms/PaymentTerms")
);

const MasterXMLParameters = lazy(() =>
  import("../_components/Master/Others/XML_Detail")
);
const SalesOffice = lazy(() =>
  import("../_components/Master/Division/SalesOfficeMaster")
);

const XMLInfo = lazy(() =>
  import("../_components/Master/Others/XmlInfo")
);

const CustCategory = lazy(() =>
  import("../_components/Master/Others/CustCategory")
);

const DocumentFinalApprover = lazy(() =>
  import("../_components/Master/Extra/DocumentFinalApprover")
);

const HSNCodeXml = lazy(() =>
  import("../_components/Master/Others/HSNCodeXml")
);

const SalesTax = lazy(() =>
  import("../_components/Master/Terms/SalesTax")
);

const DriveFlowEmp = lazy(() =>
  import("../_components/Master/Others/DriveFlowEmp")
);

const NotFoundPage = lazy(() =>
  import("./NotFoundPage")
);

const Employee = lazy(() =>
  import("../_components/Master/Others/Employee/Employee")
);

const AddEmployee = lazy(() =>
  import("../_components/Master/Others/Employee/AddEmployee")
);

const PaymentTermBinding = lazy(() =>
  import("../_components/Master/Others/PaymentTermBinding")
);

const Country = lazy(() =>
  import("../_components/Master/Extra/Country")
);

const State = lazy(() =>
  import("../_components/Master/Extra/State")
);

const Designation = lazy(() =>
  import("../_components/Master/Extra/Designation")
);

const City = lazy(() =>
  import("../_components/Master/Extra/City")
);

const Status = lazy(() =>
  import("../_components/Master/Extra/Status")
);

const AmendmentTypeDetail = lazy(() =>
  import("../_components/Master/Extra/AmendmentTypeDetail")
);

const AmendmentType = lazy(() =>
  import("../_components/Master/Extra/AmendmentType")
);

const BackupType = lazy(() =>
  import("../_components/Master/Extra/BackupType")
);

const CostOfDisassembly = lazy(() =>
  import("../_components/Master/Extra/CostOfDisassembly")
);

const DocumentType = lazy(() =>
  import("../_components/Master/Extra/DocumentType")
);

const Priority = lazy(() =>
  import("../_components/Master/Extra/Priority")
);

const Rejection = lazy(() =>
  import("../_components/Master/Extra/Rejection")
);

const Category = lazy(() =>
  import("../_components/Master/Extra/Category")
);

const ShipmentMode = lazy(() =>
  import("../_components/Master/Extra/ShipmentMode")
);


const PriorityOrderType = lazy(() =>
  import("../_components/Master/Extra/PriorityOrderType")
);

const ComplaintType = lazy(() =>
  import("../_components/Master/Extra/ComplaintType")
);

const TaxClass = lazy(() =>
  import("../_components/Master/Extra/TaxClass")
);

const Customer = lazy(() =>
  import("../_components/Customer/Customer")
);

const AddCustomer = lazy(() =>
  import("../_components/Customer/AddCustomer")
);

const CustomerView = lazy(() =>
  import("../_components/Customer/CustomerView")
);

const Cops = lazy(() =>
  import("../_components/COPS/index")
);

const AddCops = lazy(() =>
  import("../_components/COPS/AddCops")
);

const CopsWorkAssign = lazy(() =>
  import("../_components/COPS/CopsWorkAssign")
);

const COPSDashboard = lazy(() =>
  import("../_components/COPS/COPSDashboard")
);

const FlowWorkAssign = lazy(() =>
  import("../_components/Flow/FlowWorkAssign")
);
const Complaint = lazy(() =>
  import("../_components/Complaint")
);

const AddComplaint = lazy(() =>
  import("../_components/Complaint/AddComplaint")
);

const Link = lazy(() =>
  import("../_components/Master/Extra/Link")
);

const FOCReason = lazy(() =>
  import("../_components/Master/Extra/FOCReason")
);

const AddDisassembly = lazy(() =>
  import("../_components/Disassembly/AddDisassembly")
);

const DisassemblyView = lazy(() =>
  import("../_components/Disassembly/DisassemblyView")
);

const AttachmentType = lazy(() =>
  import("../_components/Master/Extra/AttachmentType")
);

const SubAttachmentType = lazy(() =>
  import("../_components/Master/Extra/SubAttachmentType")
);

const OAFailure = lazy(() =>
  import("../_components/Master/Extra/OAFailure")
);

const PP = lazy(() =>
  import("../_components/Approval/PP")
);

const AddPP = lazy(() =>
  import("../_components/Approval/PP/AddPP")
);

const DisassemblyApproval = lazy(() =>
  import("../_components/Approval/Disassembly_Approval")
);

const ApproveDisassembly = lazy(() =>
  import("../_components/Approval/Disassembly_Approval/ApproveDisassembly")
);

const FOCApproval = lazy(() =>
  import("../_components/Approval/FOC_Approval")
);

const ApprovalFOC = lazy(() =>
  import("../_components/Approval/FOC_Approval/ApprovalFOC")
);

const CustomerApproval = lazy(() =>
  import("../_components/Approval/Customer_Approval")
);

const ApprovalCustomer = lazy(() =>
  import("../_components/Approval/Customer_Approval/ApprovalCustomer")
);

const District = lazy(() =>
  import("../_components/Master/Extra/District")
);

const ConfigureFinalApproval = lazy(() =>
  import("../_components/Master/Approval/ConfigureFinalApproval")
);

const ConfigureLoginImage = lazy(() =>
  import("../_components/Master/Approval/ConfigureLoginImage")
);

const ApprovalLimit = lazy(() =>
  import("../_components/Master/Approval/ApprovalLimit")
);

const PerFormaInvoice = lazy(() =>
  import("../_components/Quotation/PerFormaInvoice")
);

const ComplaintAdministrator = lazy(() =>
  import("../_components/Master/Extra/ComplaintAdministrator")
);

const ContainerNumber = lazy(() =>
  import("../_components/Master/Extra/ContainerNumber")
);

const RightsMenu = lazy(() =>
  import("../_components/Master/Menu/Rights")
);

const Announcement = lazy(() =>
  import("../_components/Master/Others/Announcement")
);

const LinksPath = lazy(() => import("../_components/LinksPath"));

const GroupNotification = lazy(() => import("../_components/GroupNotification"));

const ComplaintCodeForCause = lazy(() =>
  import("../_components/Master/Others/ComplaintCodeForCause")
);

const LREndorsed = lazy(() =>
  import("../_components/Master/Others/LREndorsed")
);

const SEWFocSupply = lazy(() =>
  import("../_components/Master/Others/SEWFocSupply")
);

const UnitDamage = lazy(() =>
  import("../_components/Master/Others/UnitDamage")
);

const ClosingRemark = lazy(() =>
  import("../_components/Master/Others/ClosingRemark")
);

const Reports = lazy(() => import("../_components/Reports"));

const ReportSection = lazy(() => import("../_components/Reports/ReportSection"));

const Annexure = lazy(() =>
  import("../_components/Master/Extra/Annexure")
);

const CoverLetter = lazy(() =>
  import("../_components/Master/Extra/CoverLetter")
);

const MaterialType = lazy(() =>
  import("../_components/Master/Extra/MaterialType")
);

const ConfigureTagContent = lazy(() =>
  import("../_components/Master/Extra/ConfigureTagContent")
);

const MaterialGroup = lazy(() =>
  import("../_components/Master/Extra/MaterialGroup")
);

const SparePartList = lazy(() =>
  import("../_components/Master/Extra/SparePartList")
);

const DIBLauff = lazy(() =>
  import("../_components/Master/Extra/DIBLauff")
);

const DIBMo = lazy(() =>
  import("../_components/Master/Extra/DIBMo")
);
const DIBPartMaster = lazy(() =>
  import("../_components/Master/Extra/DIBPartMaster")
);

const DIBMotorData = lazy(() =>
  import("../_components/Master/Extra/DIBMotorData")
);

const DIBOR = lazy(() =>
  import("../_components/Master/Extra/DIBOR")
);

const DIBR = lazy(() =>
  import("../_components/Master/Extra/DIBR")
);

const NatureRootCause = lazy(() =>
  import("../_components/Master/Extra/NatureRootCause")
);

const CodeofNature = lazy(() =>
  import("../_components/Master/Extra/CodeofNature")
);

const BoxType = lazy(() =>
  import("../_components/Master/Extra/BoxType")
);

const ComplaintDocumentType = lazy(() =>
  import("../_components/Master/Extra/ComplaintDocumentType")
);

const Viewcops = lazy(() =>
  import("../_components/COPS/Viewcops")
);

const ComboRPMAndRatio = lazy(() => import("../_components/Master/DIB/ComboRPMAndRatio"))

const MotorPrice = lazy(() => import("../_components/Master/DIB/MotorPrice"))

const FlangePrice = lazy(() => import("../_components/Master/DIB/FlangePrice"))

const GBRRAndStage = lazy(() => import("../_components/Master/DIB/GBRRAndStage"))

const SeedingCustomerCategory = lazy(() => import("../_components/Master/Extra/SeedingCustomerCategory"));

const ConfigureDIBTag = lazy(() => import("../_components/Master/DIB/ConfigureDIBTag"));

// const CodeofNature = lazy(() =>
//   import("../_components/Master/Extra/CodeofNature")
// );




export const publicRoutes = [
  {
    title: "Login", path: "/login",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <Login />
      </Suspense>
    ),
  },
];

export const protectedRoutes = [
  {
    title: "Dashboard",
    path: "/home",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <Dashboard />
      </Suspense>
    ),
    header: true,
  },
  {
    title: "Reports",
    path: "/reports",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <Reports />
      </Suspense>
    ),
    header: true,
    subRoutes: [
      {
        title: "Reports",
        path: "/reports/:module",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <ReportSection />
          </Suspense>
        ),
        header: true,
      },
    ]
  },

  {
    title: "Quotation",
    path: "/quotation",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <Quotation />
      </Suspense>
    ),
    header: true,
    subRoutes: [
      {
        title: "Quotation",
        path: "/quotation/addQuotation",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <AddQuotation />
          </Suspense>
        ),
        header: true,

      },
      {
        title: "PerForma Invoice",
        path: "/quotation/perFormaInvoice",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <PerFormaInvoice />
          </Suspense>
        ),
        header: true,
      },
    ]
  },
  {
    title: "Amendment",
    path: "/amendment",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <Amendment />
      </Suspense>
    ),
    header: true,
    subRoutes: [
      {
        title: "AddAmendment",
        path: "/amendment/addAmendment",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <AddAmendment />
          </Suspense>
        ),
        header: true,

      },
      {
        title: "AddAmendment",
        path: "/amendment/viewAmendment",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <AmendmentView />
          </Suspense>
        ),
        header: true,

      },]
  },
  {
    title: "Disassembly",
    path: "/disassembly",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <Disassembly />
      </Suspense>
    ),
    header: true,
    subRoutes: [
      {
        title: "Disassembly",
        path: "/disassembly/addDisassembly",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <AddDisassembly />
          </Suspense>
        ),
        header: true,

      },
      {
        title: "Disassembly",
        path: "/disassembly/viewDisassembly",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <DisassemblyView />
          </Suspense>
        ),
        header: true,

      },
    ]
  },
  {
    title: "Cops",
    path: "/cops",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <Cops />
      </Suspense>
    ),
    header: true,
    subRoutes: [
      {
        title: "Cops",
        path: "/cops/addCops",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <AddCops />
          </Suspense>
        ),
        header: true,

      },
      {
        title: "Cops",
        path: "/cops/viewCops",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <Viewcops />
          </Suspense>
        ),
        header: true,

      },
    ]
  },
  {
    title: "Cops Work Assign",
    path: "/cops/copsTransfer",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <CopsWorkAssign />
      </Suspense>
    ),
    header: true,
  },
  {
    title: "Cops Dashboard",
    path: "/cops/copsDashboard",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <COPSDashboard />
      </Suspense>
    ),
    header: true,
  },
  {
    title: "Flow",
    path: "/flow",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <Flow />
      </Suspense>
    ),
    header: true,
    subRoutes: [
      {
        title: "Flow",
        path: "/flow/addFlow",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <AddFlow />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Flow",
        path: "/flow/viewFlow",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <FlowView />
          </Suspense>
        ),
        header: true,
      }
    ]
  },
  {
    title: "Flow Work Assign",
    path: "/flow/flowTransfer",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <FlowWorkAssign />
      </Suspense>
    ),
    header: true,
  },
  {
    title: "My Working Report",
    path: "/flow/myWorkingReport",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <MyWorkingReport />
      </Suspense>
    ),
    header: true,
  },
  {
    title: "Disassembly",
    path: "/disassembly",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <Disassembly />
      </Suspense>
    ),
    header: true,
    subRoutes: [
      {
        title: "Disassembly",
        path: "/disassembly/addDisassembly",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <AddDisassembly />
          </Suspense>
        ),
        header: true,

      },
    ]
  },
  {
    title: "Customer",
    path: "/customer",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <Customer />
      </Suspense>
    ),
    header: true,
    subRoutes: [
      {
        title: "Customer",
        path: "/customer/addCustomer",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <AddCustomer />
          </Suspense>
        ),
        header: true,

      },
      {
        title: "Customer",
        path: "/customer/viewCustomer",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <CustomerView />
          </Suspense>
        ),
        header: true,

      },
    ]
  },
  {
    title: "FOC",
    path: "/foc",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <FOC />
      </Suspense>
    ),
    header: true,
    subRoutes: [
      {
        title: "AddFoc",
        path: "/foc/addFoc",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <AddFoc />
          </Suspense>
        ),
        header: true,

      },
      {
        title: "AddFoc",
        path: "/foc/viewFoc",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <FocView />
          </Suspense>
        ),
        header: true,

      },
    ]
  },
  {
    title: "Complaint",
    path: "/complaint",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <Complaint />
      </Suspense>
    ),
    header: true,
    subRoutes: [
      {
        title: "Complaint",
        path: "/complaint/addComplaint",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <AddComplaint />
          </Suspense>
        ),
        header: true,

      },
    ]
  },
  {
    title: "ApprovalDashboard",
    path: "/approval",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <NotFoundPage />
      </Suspense>
    ),
    header: false,
    subRoutes: [
      {
        title: "PP",
        path: "/approval/quotation/:type",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <PP />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "AddPP",
        path: "/approval/quotation/:type/editApproval",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <AddPP />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Disassembly Approval",
        path: "/approval/disassembly",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <DisassemblyApproval />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Disassembly Approval",
        path: "/approval/disassembly/editApproval",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <ApproveDisassembly />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "FOC Approval",
        path: "/approval/foc",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <FOCApproval />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "FOC Approval",
        path: "/approval/foc/editApproval",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <ApprovalFOC />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Customer Approval",
        path: "/approval/customer/:type",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <CustomerApproval />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Add Customer Approval",
        path: "/approval/customer/:type/editApproval",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <ApprovalCustomer />
          </Suspense>
        ),
        header: true,
      },
    ]
  },
  {
    title: "MasterDashboard",
    path: "/master",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <Dashboard />
      </Suspense>
    ),
    header: true,
    subRoutes: [
      {
        title: "Emp",
        path: "/master/employee",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <Employee />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Emp",
        path: "/master/addEmployee",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <AddEmployee />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Application",
        path: "/master/application",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <Application />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Region",
        path: "/master/region",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <Region />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Branch",
        path: "/master/branch",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <Branch />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Dept",
        path: "/master/department",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <Dept />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "IndustryType",
        path: "/master/industry",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <IndustryType />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "GST_Terms",
        path: "/master/gstTerms",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <GST_Terms />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "MasterFreightTerm",
        path: "/master/masterFreight",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <MasterFreightTerm />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "MasterPlant",
        path: "/master/plant",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <MasterPlant />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "DeliveryTerms",
        path: "/master/deliveryTerms",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <DeliveryTerms />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "TransporterTerms",
        path: "/master/transporterTerms",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <TransporterTerms />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Discount",
        path: "/master/discount",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <Discount />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Announcement",
        path: "/master/announcement",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <Announcement />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "ComplaintCodeForCause",
        path: "/master/complaintCodeForCause",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <ComplaintCodeForCause />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "LREndorsed",
        path: "/master/lrEndorsed",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <LREndorsed />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "SEWFocSupply",
        path: "/master/sewFocSupply",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <SEWFocSupply />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "UnitDamage",
        path: "/master/unitDamage",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <UnitDamage />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "ClosingRemark",
        path: "/master/closingRemark",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <ClosingRemark />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "SubDept",
        path: "/master/subDept",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <SubDept />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "WarrantyType",
        path: "/master/warrantyType",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <WarrantyType />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Currency",
        path: "/master/currency",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <Currency />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "SalesOffice",
        path: "/master/salesOffice",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <SalesOffice />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "PaymentTerms",
        path: "/master/paymentTerms",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <PaymentTerms />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "WarrantyType",
        path: "/master/warrantyType",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <WarrantyType />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "DriveFlowEmp",
        path: "/master/driveFlowEmp",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <DriveFlowEmp />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "XMLInfo",
        path: "/master/xmlInfo",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <XMLInfo />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "XMLParameters",
        path: "/master/xMLParameters",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <MasterXMLParameters />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "CustCategory",
        path: "/master/custCategory",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <CustCategory />
          </Suspense>
        ),
        header: true,
      },
      // {
      //   title: "DocumentFinalApprover",
      //   path: "/master/documentFinalApprover",
      //   Component: () => (
      //     <Suspense fallback={<Loader />}>
      //       <DocumentFinalApprover />
      //     </Suspense>
      //   ),
      //   header: true,
      // },
      {
        title: "HSNCodeXML",
        path: "/master/hsnCodeXml",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <HSNCodeXml />
          </Suspense>
        ),
        header: true,
      },
      // {
      //   title: "SalesTax",
      //   path: "/master/salesTax",
      //   Component: () => (
      //     <Suspense fallback={<Loader />}>
      //       <SalesTax />
      //     </Suspense>
      //   ),
      //   header: true,
      // },
      {
        title: "PaymentTermBinding",
        path: "/master/paymentTermBinding",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <PaymentTermBinding />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Country",
        path: "/master/country",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <Country />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "State",
        path: "/master/state",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <State />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Designation",
        path: "/master/designation",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <Designation />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "District",
        path: "/master/district",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <District />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "City",
        path: "/master/city",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <City />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Status",
        path: "/master/status",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <Status />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Amendment Type",
        path: "/master/amendmentMaster",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <AmendmentType />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "BackupType",
        path: "/master/backupType",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <BackupType />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Cost Debit To",
        path: "/master/costDebitTo",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <CostOfDisassembly />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "DocumentType",
        path: "/master/documentType",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <DocumentType />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Priority",
        path: "/master/priority",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <Priority />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Rejection",
        path: "/master/rejection",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <Rejection />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Category",
        path: "/master/category",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <Category />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "ShipmentMode",
        path: "/master/shipmentMode",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <ShipmentMode />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "AmendmentTypeDetail",
        path: "/master/amendmentTypeDetail",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <AmendmentTypeDetail />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "PriorityOrderType",
        path: "/master/priorityOrderType",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <PriorityOrderType />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "ComplaintType",
        path: "/master/complaintType",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <ComplaintType />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "TaxClass",
        path: "/master/taxClass",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <TaxClass />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Link",
        path: "/master/link",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <Link />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "FOC Reason",
        path: "/master/focReason",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <FOCReason />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Attachment Type",
        path: "/master/attachmentType",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <AttachmentType />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Sub Attachment Type",
        path: "/master/subAttachmentType",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <SubAttachmentType />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "OAFailure",
        path: "/master/oaFailure",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <OAFailure />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "District",
        path: "/master/district",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <District />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "ConfigureFinalApproval",
        path: "/master/configureFinalApproval",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <ConfigureFinalApproval />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "ConfigureLoginImage",
        path: "/master/configureLoginImage",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <ConfigureLoginImage />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "ApprovalLimit",
        path: "/master/approvalLimit",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <ApprovalLimit />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "ComplaintAdministrator",
        path: "/master/complaintAdministrator",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <ComplaintAdministrator />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "ContainerNumber",
        path: "/master/containerNumber",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <ContainerNumber />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Menu",
        path: "/master/menuRights",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <RightsMenu />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Material Group",
        path: "/master/materialGroup",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <MaterialGroup />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Spare Part List",
        path: "/master/sparePartList",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <SparePartList />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "DIB Lauff",
        path: "/master/dibLauff",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <DIBLauff />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "DIB Mo",
        path: "/master/dibMo",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <DIBMo />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "DIB Part",
        path: "/master/dibPart",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <DIBPartMaster />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "DIB Motor Data",
        path: "/master/dibMotorData",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <DIBMotorData />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "DIB OR",
        path: "/master/dibOR",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <DIBOR />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "DIB R",
        path: "/master/dibR",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <DIBR />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Combo RPM And Ratio",
        path: "/master/comboRpmRatio",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <ComboRPMAndRatio/>
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Motor Price",
        path: "/master/motorPrice",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <MotorPrice />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Flange Price",
        path: "/master/flangePrice",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <FlangePrice />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "GBRR And Stage",
        path: "/master/gbrrStage",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <GBRRAndStage />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Nature Root Cause",
        path: "/master/natureRootCause",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <NatureRootCause />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Code of Nature",
        path: "/master/codeofNature",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <CodeofNature />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Box Type",
        path: "/master/boxType",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <BoxType />
          </Suspense>
        ),
        header: true,
      },
      {
        title: "Box Type",
        path: "/master/complaintDocumentType",
        Component: () => (
          <Suspense fallback={<Loader />}>
            <ComplaintDocumentType />
          </Suspense>
        ),
        header: true,
      },
    ],
  },
  {
    title: "Links",
    path: "/linksPath",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <LinksPath />
      </Suspense>
    ),
    header: true,
  },
  {
    title: "Profile",
    path: "/profile",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <Profile />
      </Suspense>
    ),
    header: true,
  },
  {
    title: "Email",
    path: "/email",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <GroupNotification />
      </Suspense>
    ),
    header: true,
  },
  {
    title: "Annexure",
    path: "/master/annexure",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <Annexure />
      </Suspense>
    ),
    header: true,
  },
  {
    title: "CoverLetter",
    path: "/master/coverLetter",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <CoverLetter />
      </Suspense>
    ),
    header: true,
  },
  {
    title: "MaterialType",
    path: "/master/materialType",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <MaterialType />
      </Suspense>
    ),
    header: true,
  },
  {
    title: "ConfigureTagContent",
    path: "/master/configureTagContent",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <ConfigureTagContent />
      </Suspense>
    ),
    header: true,
  },
  {
    title: "CustomerCategory",
    path: "/master/CustomerCategory",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <SeedingCustomerCategory />
      </Suspense>
    ),
    header: true,
  },
  {
    title: "ConfigureDIBTag",
    path: "/master/ConfigureDIBTag",
    Component: () => (
      <Suspense fallback={<Loader />}>
        <ConfigureDIBTag />
      </Suspense>
    ),
    header: true,
  },
];
